
import ModelWithFacilityApi from "./ModelWithFacilityApi";

export default class HvacApi extends ModelWithFacilityApi {
    constructor(token, clientId, onUnathorized) {
        super(token, clientId, onUnathorized);
        this.baseUrl = this.getBaseUrl() + "hvac/";
    }

    async getPerformanceReport(fromDate, toDate, onSuccess, onError) {
        this.Get(
            this.baseUrl +
            `performance/?start_date=${fromDate.toISOString().split("T")[0]}&end_date=${toDate.toISOString().split("T")[0]}`,
            onSuccess,
            onError,
        );

    }

    async getPortfolioSavingsReport(fromDate, toDate, onSuccess, onError) {
        this.Get(
            this.baseUrl + `performance_report_per_date/?start_date=${fromDate.toISOString().split("T")[0]}&end_date=${toDate.toISOString().split("T")[0]}`,
            onSuccess,
            onError,
        )
    }

    async getPerformanceBreakdown(date, onSuccess, onError) {
        this.Get(
            this.baseUrl + `performance_report_with_breakdown/?date=${date.toISOString().split("T")[0]}`,
            onSuccess,
            onError,
        );
    }

    async getFacilityPerformanceBreakdown(facility, date, onSuccess, onError) {
        this.Get(
            this.baseUrl + `facility_breakdown_by_hvac/?date=${date.toISOString().split("T")[0]}&facility=${facility.split("/").slice(-2)[0]}`,
            onSuccess,
            onError,
        );
    }

    async changeValue(hvac, key, newValue, unmanage, onSuccess, onError) {
        let response;
        try {
            response = await fetch((hvac + "change_value/").replace("client_id", this.getClientID()),
                {
                    method: "POST",
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': this.getToken()
                    },
                    body: JSON.stringify(
                        {
                            "key": key,
                            "value": newValue,
                            "unmanage": unmanage
                        }
                    ),
                }
            )
        } catch (err) {
            onError({ "non_field_errors": "Problem connecting with server." });
            return;
        }

        if (response.ok) {
            onSuccess();
        } else if (response.status === 400) {
            onError();
        } else if (response.status === 401) {
            this.onUnauthorized()
        } else {
            onError({ "non_field_errors": "Unexpected problem when trying to change value." });
        }
    }

    async changeValueForAllInFacility(facility, key, newValue, unmanage, onLoopCompletion, onBlockingError) {
        let hvacUrls = [];
        let onErrorCalled = false;

        const onListSuccess = (data) => {
            hvacUrls = data.map((hvac) => {
                return hvac.url;
            });

            let successIds = []
            let errorsDict = {} // hvacId: error


            hvacUrls.forEach(async (hvacUrl) => {
                await this.changeValue(
                    hvacUrl,
                    key,
                    newValue,
                    unmanage,
                    () => {
                        successIds.push(hvacUrl);
                    },
                    () => {
                        errorsDict[hvacUrl] = "Error changing value";
                    }
                )
            })
            onLoopCompletion(successIds, errorsDict);
        }
        const onListError = () => {
            onBlockingError()
            onErrorCalled = true;
            return
        }
        await this.list(
            facility,
            onListSuccess,
            onListError
        )
        if (onErrorCalled) {
            return;
        }
    }
}